import React, { useState, useEffect } from 'react';
import { XGrid } from '@material-ui/x-grid';
import QuickSearch from '../QuickSearch';
import { searchAddresses } from 'reducers/SearchReducer';

let lastSearchTerm = '';

function MergeAddrTargetDialog(props) {
  const { columns, setSourceID, targetID } = props;
  const [rawRows, setRawRows] = useState([]);
  const [selectedIDs, setSelectedIDs] = useState([]);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [loaded, setLoaded] = useState(true);
  const [ViewDeleted] = useState(false);
  const limit = 1000;

  useEffect(() => {
    const r = props.rows.filter((x) => x.id !== targetID && !x.IsDeleted);
    setRawRows(r);
  }, []);

  const search = async (text = lastSearchTerm, offset = 0) => {
    lastSearchTerm = text;
    if (!text || text.length < 3) return;
    setLoaded(false);
    searchAddresses(text, ViewDeleted, 2, offset, limit)
      .then((result) => {
        setRawRows(result);
      })
      .finally(() => setLoaded(true));
  };

  const processedRows = React.useMemo(() => {
    const newRows = rawRows.map((row) => ({
      ...row,
      id: row.ptsAddressID + ' ' + row.AddressID,
    }));

    const merged = [...selectedRowsData, ...newRows];

    return Array.from(new Map(merged.map((r) => [r.id, r])).values());
  }, [rawRows, selectedRowsData]);

  const normalizeSelection = (payload) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.selectionModel)) return payload.selectionModel;
    return [];
  };

  const handleSelectChange = (payload) => {
    const sel = normalizeSelection(payload);
    setSelectedIDs(sel);
    const selected = processedRows.filter((r) => sel.includes(r.id));
    setSelectedRowsData(selected);
    const sourceIds = selected.map((r) => r.ptsAddressID);
    setSourceID(sourceIds);
    props.setRows((prevRows) => {
      const existingIdSet = new Set(prevRows.map((r) => r.ptsAddressID));
      const missingRows = selected.filter((s) => !existingIdSet.has(s.ptsAddressID));
      return [...prevRows, ...missingRows];
    });
  };

  return (
    <>
      <QuickSearch search={search} loaded={loaded} />

      <div style={{ height: 500 }}>
        <XGrid
          columns={columns}
          rows={processedRows}
          checkboxSelection
          selectionModel={selectedIDs}
          onSelectionModelChange={handleSelectChange}
        />
      </div>
    </>
  );
}

export default MergeAddrTargetDialog;
